export interface GoogleServicesState {
    enabled: boolean;
}

export const googleServicesInitialState: GoogleServicesState = {
    enabled: false,
};
